import React from 'react';
import { Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const Payments = () => {
  const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  }));
  return (
    <Box>
      <DrawerHeader />
      <Typography variant="h4" sx={{ marginBottom: 2 }}>
        Welcome to the Payments
      </Typography>
      <Typography sx={{ marginBottom: 2 }}>
        This is content of Dashboard
        tempor incididunt ut labore et dolore magna aliqua. Rhoncus dolor purus non
        enim praesent elementum facilisis leo vel. Risus at ultrices mi tempus
        imperdiet.
      </Typography>
      <Typography sx={{ marginBottom: 2 }}>
        Consequat mauris nunc congue nisi vitae suscipit. Fringilla est ullamcorper
        eget nulla facilisi etiam dignissim diam.
      </Typography>
    </Box>
  );
};

export default Payments;
